import { ApiError } from '@fusapp-work/api'
import { z } from 'zod'
import { consoleMaxPages } from './listPageLimits'
export { consoleMaxPages, consolePageSize } from './listPageLimits'

export function listPageSchema<T extends z.ZodType>(item: T, sort: string) {
  return z.object({
    items: z.array(item), page: z.number().int().positive(), size: z.union([z.literal(25), z.literal(50), z.literal(100)]),
    totalCount: z.number().int().nonnegative(), totalUnfiltered: z.number().int().nonnegative(), appliedSort: z.literal(sort),
  })
}
export interface ListPage<T> {
  items: T[]; page: number; size: number; totalCount: number; totalUnfiltered: number; appliedSort: string
}

/** D1 / FW-605: client pagers and charts require the complete backend list. Never cache a partial traversal. */
export async function collectListPages<T>(first: ListPage<T>, next: (page: number) => Promise<ListPage<T>>): Promise<T[]> {
  if (first.totalCount > consoleMaxPages * first.size) throw new ApiError('Console list exceeds page limit', 200, 'INVALID_RESPONSE')
  const items: T[] = []
  let current = first
  for (let page = 1; page <= consoleMaxPages; page++) {
    const expected = Math.min(first.size, Math.max(0, first.totalCount - (page - 1) * first.size))
    if (current.page !== page || current.size !== first.size || current.totalCount !== first.totalCount
      || current.totalUnfiltered !== first.totalUnfiltered || current.totalUnfiltered < current.totalCount
      || current.appliedSort !== first.appliedSort || current.items.length !== expected) {
      throw new ApiError('Inconsistent Console list page', 200, 'INVALID_RESPONSE')
    }
    items.push(...current.items)
    if (items.length === first.totalCount) return items
    if (page < consoleMaxPages) current = await next(page + 1)
  }
  throw new ApiError('Console list exceeds page limit', 200, 'INVALID_RESPONSE')
}
